import {
  getPermissions as getPermissionsService,
  createPermissions as createPermissionService,
} from "services/admin/roleManagement/permission/permissionService";
import {
  getPermissionsStart,
  getPermissionsSuccess,
  getPermissionsFailure,
  createPermissionStart,
  createPermissionSuccess,
  createPermissionFailure,
} from "./permissionSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all permissions
export const fetchPermissions = () => async (dispatch) => {
  try {
    dispatch(getPermissionsStart());
    const response = await getPermissionsService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getPermissionsSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch permissions";
      dispatch(getPermissionsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch permissions error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch permissions";
    dispatch(getPermissionsFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new permission
export const createNewPermission = (permissionData) => async (dispatch) => {
  try {
    dispatch(createPermissionStart());
    const response = await createPermissionService(permissionData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createPermissionSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Permission created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create permission";
      dispatch(createPermissionFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create permission error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create permission";
    dispatch(createPermissionFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
